import { Route, Routes } from '@angular/router';

import { UpdatesComponent } from './updates.component';
import { UpdateDeletePopupComponent, UpdateDeleteComponent } from './update-delete.component';
import { UserRouteAccessService } from '../../services';

export const UPDATES_ROUTE: Route = {
    path: 'updates',
    component: UpdatesComponent,
    data: {
        authorities: ['ROLE_SUPER_ADMIN'],
        pageTitle: 'update.tabTitle'
    },
    canActivate: [UserRouteAccessService]
};

export const UPDATES_POPUPS_ROUTES: Routes = [
    {
        path: 'updates/delete/:id',
        component: UpdateDeletePopupComponent,
        data: {
            authorities: ['ROLE_SUPER_ADMIN'],
            pageTitle: 'update.tabTitle',
            modalComponent: UpdateDeleteComponent
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/updates/updates.route.ts